import {useQuery} from '@tanstack/react-query'

import {getRentalReport} from './api'
import {rentalReportKeys} from './query-keys'

export function useRentalReport(startDate: string, endDate: string) {
    return useQuery({
        queryKey: rentalReportKeys.report(startDate, endDate),
        queryFn: () => getRentalReport(startDate, endDate),
    })
}
